<template>
	<div v-parallax-fit="parallax" class="slide-hand" id="slidehand-2">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/08_grabbinghand_02.png">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 15500,
						end: 17000,
						fromStyle: { transform: 'translateY(0%)', opacity: 0 },
           				toStyle: { transform: 'translateY(-50%)', opacity: 1 },
						easing: 'linear'
					},
					{
						start: 17000,
						end: 18000,
						fromStyle: { transform: 'translateY(-50%)' },
           				toStyle: { transform: 'translateY(-48%)', },
						easing: 'linear'
					},
					{
						start: 18000,
						end: 19000,
						fromStyle: { transform: 'translateY(-48%)' },
           				toStyle: { transform: 'translateY(40%)', opacity: 0 },
						easing: 'linear'
					}
				]
			}
		},
	}
</script>

<style lang="scss" scoped>
	.slide-hand {
		position: absolute;
	    top: 140%;
	    left: 18%;
	    max-width: 250px;
	    transition: all 0.1s linear;
	}

	@media screen and (max-width: 1440px) {
		.slide-hand {
		    top: 155%;
		    max-width: 200px;
		}
	}

	@media screen and (max-width: 1280px) {
		.slide-hand {max-width: 135px;}
	}

	@media screen and (max-width: 650px) {
		.slide-hand {
			max-width: 65px;
			left: 13%;
		}
	}
</style>
